import { render } from "./trainStat.vue?vue&type=template&id=2a26ace9&scoped=true"
import script from "./trainStat.vue?vue&type=script&lang=js"
export * from "./trainStat.vue?vue&type=script&lang=js"

import "./trainStat.vue?vue&type=style&index=0&id=2a26ace9&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a26ace9"]])

export default __exports__